import { ColumnStore } from "@bryntum/schedulerpro";
import { WIDGET_KEYS } from "../../other/constants/WidgetKeys.jsx";
import { columnAvatarConfig, columnAvatarString, getCustomGroupRenderer, swivuGridSorterFn } from "../../other/utils/utils.jsx";
import ColumnBase from "./ColumnBase.jsx";
import { STORE_KEYS } from "../../other/constants/StoreKeys.jsx";

export default class NotifyColumn extends ColumnBase {
  static get $name() {
    return "NotifyColumn";
  }

  static get fields() {
    return [
      { name: "swivuListTitle", readOnly: true, type: "string", defaultValue: "Notify"  },
      { name: "canMultiSelectSwivuList", readOnly: true, defaultValue: true },
    ];
  }

  static get type() {
    return WIDGET_KEYS.notifyColumn;
  }

  static get defaults() {
    return {
      field: "notifyees",
      cellCls: "swivu-recipients-cell gap-[0.3em]",
      flex: "1 1 100%",
      groupRenderer(e) {
        return getCustomGroupRenderer(e, "notifyees");
      },
      editor: false,
      tooltipRenderer: columnAvatarConfig.tooltipRenderer
    };
  }

  get swivuListItems() {
    return this.project
      .getCrudStore(STORE_KEYS.boardUserStore)
      .query(() => true, true).sort(swivuGridSorterFn.bind({ field: "name" })) || [];
  }

  onLoad(project) {
    this.project = project;
  }

  renderer({ record, size }) {
    if (!record.isGroupHeader && this.project) {
      const recordTags = record.notifyees.map((item) =>
        this.project.boardUsersStore.getById(item)
      );

      return recordTags.map(record => columnAvatarConfig.columnAvatarRenderer({
        image: record.profileImageURL,
        name: record.name,
        size: size.configuredHeight,
        archived: record.archived,
        showName: false
      }))
    }
  }

  getSwivuListItemDisplayValue(record) {
    return columnAvatarString(record.name, record.profileImageURL);
  }

  getSelectedSwivuListItem(record) {
    return this.swivuListItems.filter((item) =>
      record.notifyees.includes(item?.id)
    );
  }

  onSwivuListSelectionChange(record, notifyeesRecord) {
    record.notifyees = notifyeesRecord.map((item) => item.id);
  }
}

ColumnStore.registerColumnType(NotifyColumn);